"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Party = void 0;
var Party;
(function (Party) {
    /**
     * User language setting.
     */
    let locale;
    (function (locale) {
        locale["NL"] = "NL";
        locale["FR"] = "FR";
    })(locale = Party.locale || (Party.locale = {}));
    /**
     * Gender.
     */
    let gender;
    (function (gender) {
        gender["MALE"] = "MALE";
        gender["FEMALE"] = "FEMALE";
    })(gender = Party.gender || (Party.gender = {}));
    /**
     * Social status.
     */
    let socialStatus;
    (function (socialStatus) {
        socialStatus["_13"] = "13";
        socialStatus["_10"] = "10";
        socialStatus["_01"] = "01";
        socialStatus["_36"] = "36";
        socialStatus["_99"] = "99";
    })(socialStatus = Party.socialStatus || (Party.socialStatus = {}));
    /**
     * Civil status.
     */
    let civilStatus;
    (function (civilStatus) {
        civilStatus["_1"] = "1";
        civilStatus["_6"] = "6";
        civilStatus["_2"] = "2";
        civilStatus["_99"] = "99";
    })(civilStatus = Party.civilStatus || (Party.civilStatus = {}));
})(Party = exports.Party || (exports.Party = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZ2VuZXJhdGVkL3NjaGVtYS50cy9tb2RlbHMvUGFydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDBCQUEwQjtBQUMxQixvQkFBb0I7QUFDcEIsb0JBQW9COzs7QUFxRHBCLElBQWlCLEtBQUssQ0F3Q3JCO0FBeENELFdBQWlCLEtBQUs7SUFFbEI7O09BRUc7SUFDSCxJQUFZLE1BR1g7SUFIRCxXQUFZLE1BQU07UUFDZCxtQkFBUyxDQUFBO1FBQ1QsbUJBQVMsQ0FBQTtJQUNiLENBQUMsRUFIVyxNQUFNLEdBQU4sWUFBTSxLQUFOLFlBQU0sUUFHakI7SUFFRDs7T0FFRztJQUNILElBQVksTUFHWDtJQUhELFdBQVksTUFBTTtRQUNkLHVCQUFhLENBQUE7UUFDYiwyQkFBaUIsQ0FBQTtJQUNyQixDQUFDLEVBSFcsTUFBTSxHQUFOLFlBQU0sS0FBTixZQUFNLFFBR2pCO0lBRUQ7O09BRUc7SUFDSCxJQUFZLFlBTVg7SUFORCxXQUFZLFlBQVk7UUFDcEIsMEJBQVUsQ0FBQTtRQUNWLDBCQUFVLENBQUE7UUFDViwwQkFBVSxDQUFBO1FBQ1YsMEJBQVUsQ0FBQTtRQUNWLDBCQUFVLENBQUE7SUFDZCxDQUFDLEVBTlcsWUFBWSxHQUFaLGtCQUFZLEtBQVosa0JBQVksUUFNdkI7SUFFRDs7T0FFRztJQUNILElBQVksV0FLWDtJQUxELFdBQVksV0FBVztRQUNuQix1QkFBUSxDQUFBO1FBQ1IsdUJBQVEsQ0FBQTtRQUNSLHVCQUFRLENBQUE7UUFDUix5QkFBVSxDQUFBO0lBQ2QsQ0FBQyxFQUxXLFdBQVcsR0FBWCxpQkFBVyxLQUFYLGlCQUFXLFFBS3RCO0FBR0wsQ0FBQyxFQXhDZ0IsS0FBSyxHQUFMLGFBQUssS0FBTCxhQUFLLFFBd0NyQiJ9